export default __webpack_public_path__ + "static/media/Sort_desc.5cf017d5.svg";